import { useToastStore } from '@/features/toasts/stores/useToastStore';
import { useBackendApi } from '@/services/useBackendApi';
import { useMutation, useQueryCache } from '@pinia/colada';
import ReceiveCoinsToast from '../components/ReceiveCoinsToast.vue';

interface IResult {
    claimed: number
}

export function useDailyBonusClaim() {
    const Api = useBackendApi();
    const queryCache = useQueryCache();
    const toast = useToastStore();

    return useMutation<IResult>({
        mutation: () => Api.post(`/earn/user/claim_daily_gift`),
        onSuccess: (result) => {
            queryCache.invalidateQueries({ key: ['user'] });

            toast.addToast({
                status: 'success',
                content: ReceiveCoinsToast,
                props: {
                    message: 'Daily gift clamied',
                    amount: result.claimed
                }
            });
        }
    });
}
